var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPvProduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.986816,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#FCC274"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.06 11.9868V14.8268L21.9 13.4028L19.06 11.9868ZM18.26 16.7868L16.3 18.7548L19.3 19.7548L18.26 16.7868ZM11.5 19.5468L12.916 22.3868L14.34 19.5468H11.5ZM17.9 11.9868H11.5V18.3868C11.956 18.5228 12.436 18.5868 12.916 18.5868C15.78 18.5948 18.108 16.2668 18.116 13.3868C18.108 12.9148 18.036 12.4428 17.9 11.9868ZM23.5 27.9868V23.1868H21.1L25.1 15.9868V20.7868H27.5L23.5 27.9868Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvProduction);
export default __webpack_public_path__ + "static/media/pvProduction.62fc6cc7f76dd35cb5d7c77eff3b3228.svg";
export { ForwardRef as ReactComponent };